import React from 'react'

const CalltracksPhoneNumber = ({
  phoneNumber,
  calltracksClass,
  className,
  spanOnly
}) => {
  const classes = [calltracksClass].concat(className || []).join(' ')

  if (spanOnly) {
    return <span className={classes}>{phoneNumber}</span>
  }

  return (
    <a href={`tel:${phoneNumber}`}>
      <span className={classes}>{phoneNumber}</span>
    </a>
  )
}

export default CalltracksPhoneNumber
